<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  statisticNoteTotalPublic?: any;
}>();

const emits = defineEmits<{
  handleFilterTotal: [dataFilter: any];
  applyNewValue: [noteData: any];
}>();

const { t } = useI18n({ useScope: 'global' });
const initNoteData = () => {
  return [
    {
      key: 1,
      icon: 'pi pi-users',
      label: t('my_quote.unread'),
      total: props.statisticNoteTotalPublic['UNREAD']?.count,
      quoteIds: props.statisticNoteTotalPublic['UNREAD']?.quoteIds,
      totalShow: props.statisticNoteTotalPublic['UNREAD']?.quoteIds?.length
    },
    {
      key: 2,
      icon: 'pi pi-dollar',
      label: t('note.acknowledged'),
      total: props.statisticNoteTotalPublic['ACKNOWLEDGE']?.count,
      quoteIds: props.statisticNoteTotalPublic['TOTAL']?.quoteIds?.filter((id: string) => !props.statisticNoteTotalPublic['UNREAD']?.quoteIds?.includes(id)),
      totalShow: props.statisticNoteTotalPublic['TOTAL']?.quoteIds?.length - props.statisticNoteTotalPublic['UNREAD']?.quoteIds?.length
    },
    {
      key: 3,
      icon: 'pi pi-chart-line',
      label: t('note.all_unread_acknowledged'),
      total: props.statisticNoteTotalPublic['TOTAL']?.count,
      quoteIds: props.statisticNoteTotalPublic['TOTAL']?.quoteIds,
      totalShow: props.statisticNoteTotalPublic['TOTAL']?.quoteIds?.length
    }
  ];
};
const noteData = ref(initNoteData());

const handleFilterData = (item: any) => {
  emits('handleFilterTotal', item);
};

watch(
  () => props.statisticNoteTotalPublic,
  () => {
    noteData.value = initNoteData();
    emits('applyNewValue', noteData.value);
  },
  { deep: true }
);
</script>

<template>
  <div class="gqt-surface-ground">
    <div class="grid">
      <div v-for="item in noteData" :key="item.key" class="col-12 md:col-6 lg:col-2" @click="handleFilterData(item)">
        <a class="no-underline cursor-pointer">
          <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
              <div>
                <i class="mr-3" :class="item.icon"></i><b>{{ $t('my_quote.notes') }}</b>
                <div class="h-4rem">
                  <span class="block font-medium mb-3">{{ item.label }}</span>
                </div>
                <div class="text-900 font-medium">{{ item.total }}</div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
